import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import Button from '@mui/material/Button';
import type { ReactNode } from 'react';
import { TOOLBAR_ICON_BUTTON_SX } from './utils';

export function ExportCsvButton({
  onClick,
  disabled,
  dataTest,
  label = 'Export',
}: {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  dataTest?: string;
}): ReactNode {
  return (
    <Button
      data-test={dataTest}
      variant="outlined"
      size="small"
      disabled={disabled}
      onClick={onClick}
      startIcon={<FileDownloadOutlined sx={{ fontSize: 18 }} />}
      sx={[TOOLBAR_ICON_BUTTON_SX, { fontWeight: 600, textTransform: 'none' }]}
    >
      {label}
    </Button>
  );
}
